import React, { useMemo } from 'react';

import get from 'lodash/get';

import { Typography, styled, Stack } from '@gogame/components';

const Title = styled(Typography)`
  text-transform: uppercase;
`;

export default ({ data }) => {
  const onlyApplication = get(data, 'onlyApplication', false);
  const applications = get(data, 'applications', []);
  const excludeApplications = get(data, 'excludeApplications', []);

  const applicationsJoined = useMemo(
    () => applications.map(({ name }) => name).join(', '),
    applications
  );
  const excludeApplicationsJoined = useMemo(
    () => excludeApplications.map(({ name }) => name).join(', '),
    excludeApplications
  );

  return (
    <Stack>
      <Stack direction={'row'}>
        {onlyApplication ? (
          <Title color={'textSecondary'}>Only: &nbsp;</Title>
        ) : null}
        <Typography>{applicationsJoined}</Typography>
      </Stack>

      {excludeApplicationsJoined ? (
        <Stack direction={'row'}>
          <Title color={'textSecondary'}>Excluded:</Title> &nbsp;
          <Typography>{excludeApplicationsJoined}</Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};
